import * as amplitude from '@amplitude/analytics-browser';

const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;
const isProduction = Boolean(apiKey);

export const amplitudeInit = () => {
  if (isProduction) {
    try {
      amplitude.init(import.meta.env.VITE_AMPLITUDE_API_KEY, { "autocapture": true });
    } catch (error) {
      console.error("Error initializing Amplitude", error);
    }
  }
}

export const amplitudeAddTrack = (event: string, properties: object) => {
  if (isProduction && apiKey !== 'undefined' && apiKey !== null) {
    try {
      amplitude.track(event, {
        timestamp: new Date().toISOString(),
        ...properties,
      });
    } catch (error) {
      console.error("Error tracking event", error);
    }
  }
}

export const determineProjectName = (event: string) => {
  const projectName = import.meta.env.VITE_PROJECT_NAME;
  return projectName ? `${event} - ${projectName}` : `${event} - Persea wallet`;
}
